import React from 'react';
import { appRoutes } from '../../../routes/routes';
import { subscribeToZohoPeopleStatus } from '../../../services/zohoPeople';
import { IntegrationTile } from './IntegrationTile.component';

export const ZohoPeopleTile = () => (
  <IntegrationTile
    name="Zoho People"
    description="Push Prodaff tracked hours to Zoho People as attendance records."
    logoText="Zoho"
    logoColor="#e8251a"
    route={appRoutes().integrationsZohoPeople}
    subscribeToStatus={subscribeToZohoPeopleStatus}
  />
);
